export default __webpack_public_path__ + "static/media/live-icon.5c293010.webp";